import { InputNumberLocalized } from '@components'

import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useGetZervantDocumentSettings } from '@features/invoicingSettings/hooks/useGetZervantDocumentSettings'

import { useDebouncedCallback } from '../../../../../../../../../../../../../../../../../../hooks/useDebouncedCallback'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useUpdateDependentLineValues } from '../../../../../../../../../../hooks/useUpdateDependentLineValues'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineQuantityProps = CommonInvoiceLineFieldProps

export const InvoiceLineQuantity = ({ disabled = false, lineIndex }: InvoiceLineQuantityProps) => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm
  const { handleQuantityChange } = useUpdateDependentLineValues()
  const { getInvoiceLocale } = useGetZervantDocumentSettings(InvoiceDocumentType.Invoice)
  const locale = getInvoiceLocale()

  const handleDebouncedInputNumberChange = useDebouncedCallback((quantity: number) =>
    trackInvoiceEditor('Form - Invoice lines - Quantity changed', {
      quantity,
    }),
  )

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.quantity`}
      render={({ field: { onChange, ...rest } }) => {
        return (
          <InputNumberLocalized
            {...rest}
            aria-label={t('external_invoices.editor.form.field.line.header.quantity')}
            disabled={disabled}
            keyboard
            locale={locale}
            withCalculations={false}
            min={0}
            onChange={(quantity) => {
              handleQuantityChange(lineIndex, quantity)
              onChange(quantity)
              handleDebouncedInputNumberChange(quantity)
            }}
            size="sm"
          />
        )
      }}
    />
  )
}
